export class TimeMeasurer {
  private ts: number
  prefix: string | null = null

  constructor() {
    this.ts = Date.now()
  }

  log(label: string) {
    console.info(`${this.prefix ? `${this.prefix} ` : ''}[${label}]`, 'at', this.diff())
  }

  diff() {
    return `${Date.now() - this.ts}ms`
  }
}
